<script setup lang="ts">
import StatisticCard from '@features/statistics/components/StatisticCard/StatisticCard.vue'

import { useDailyStatistics } from '@features/statistics/composables/useDailyStatistics'

const { isFetchError, dailyStatisticsList } = await useDailyStatistics()
</script>

<template>
  <div v-if="!isFetchError" id="dailyStatistics" class="daily-statistics">
    <h2 class="daily-statistics__title">Цифры дня</h2>
    <div class="daily-statistics__list">
      <statistic-card
        v-for="(statistic, index) in dailyStatisticsList"
        :key="statistic.title"
        class="daily-statistics__statistic"
        :class="`v-statistic--${index}`"
        :statistic="statistic"
        :index="index"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.daily-statistics {
  @include media($bp-tablet) {
    padding-bottom: 142px;
  }

  @include media($bp-desktop) {
    padding-bottom: 0;
  }

  &__title {
    margin-bottom: 40px;
    font-size: 30px;
    font-weight: 800;
    color: var(--ui-color-white);

    @include media($bp-tablet) {
      font-size: 40px;
    }
  }

  &__list {
    position: relative;
    width: calc(100% - 17px);
    height: 720px;
    margin-left: 17px;
    overflow: hidden;

    @include media($bp-tablet) {
      width: 463px;
      height: 532px;
      margin-left: 0;
      overflow: auto;
    }
  }

  &__statistic {
    position: absolute;
  }

  .v-statistic--0 {
    top: 24px;
    left: 1px;

    @include media($bp-tablet) {
      top: 30px;
      left: 0;
    }
  }

  .v-statistic--1 {
    top: 133px;
    right: 64px;

    @include media($bp-tablet) {
      top: 75px;
      right: auto;
      left: 188px;
    }
  }

  .v-statistic--2 {
    top: 650px;
    right: 86px;

    @include media($bp-tablet) {
      top: 461px;
      right: auto;
      left: 49px;
    }
  }

  .v-statistic--3 {
    top: 380px;
    right: 30px;

    @include media($bp-tablet) {
      top: 239px;
      right: auto;
      left: 288px;
    }
  }

  .v-statistic--4 {
    top: 270px;
    left: 12px;

    @include media($bp-tablet) {
      top: 256px;
      left: 18px;
    }
  }

  .v-statistic--5 {
    top: 515px;
    left: 1px;

    @include media($bp-tablet) {
      top: 412px;
      left: 278px;
    }
  }
}
</style>
